export default {
  allPartStocks: [],
}
